<template>
  <div class=" flex justify-center col-12 p3">
    <div class="col-12 flex flex-wrap justify-center white-bg">
      <div class="my2 px2 center">
        <h2>{{ getReferencelabel("APIS_TITLE") }}</h2>
        <!-- <span> {{ getReferencelabel("APIS_DESCRIPTION") }} </span> -->
      </div>
      <iframe
        id="iframe-size-google-forms"
        width="100%"
        src="https://docs.google.com/forms/d/e/1FAIpQLSeItxMcQKnZ6HmlXhejUfopAmSM1yjVeWibGAU-2DIKsg2MAg/viewform?embedded=true"
        :onload="loading"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>
<script>

import { useStore } from 'vuex';
import { getReferencelabel } from '@/mixins/utils';

export default {
  setup () {
    const store = useStore();

    store.commit('setLoading', true);

    function loading () {
      store.commit('setLoading', false);
    }

    return { getReferencelabel, loading };
  }
};
</script>
